import { Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { INDRAIbeAdminMktService } from '@ibe.services/ibeadmin-mkt.indra.service';

@Injectable({
	providedIn: 'root'
})
export class INDRAIBEEmailTesterService {
	
	CONFIRMATION_COMMERCIAL_JSON = './assets/data/email-mock-objects/email_confirmation_commercial.json';
	CONFIRMATION_AWARD_JSON = './assets/data/email-mock-objects/email_confirmation_award.json';
	CONFIRMATION_TTT_JSON = './assets/data/email-mock-objects/email_confirmation_TTT.json';
	TTT_WARNING_JSON = './assets/data/email-mock-objects/email_TTT_expiration_warning.json';
	TTT_EXPIRED_JSON = './assets/data/email-mock-objects/email_TTT_expired.json';
	CONFIRMATION_STOPOVER_JSON = './assets/data/email-mock-objects/email_confirmation_stopover.json';
	CONFIRMATION_COMMERCIAL_BRAZIL_TAXES_JSON = './assets/data/email-mock-objects/email_confirmation_commercial_brazil_taxes.json';
	ADD_MORE_COMMERCIAL_JSON = './assets/data/email-mock-objects/email_add_more_commercial.json';


	constructor(
		protected _http: HttpClient,
		private ibeAdminMarketService: INDRAIbeAdminMktService
	) {}
	
	private async sendEmail(campaignId, emailTo, jsonFilePath) {

		const params = await this._http.get(jsonFilePath).toPromise();
		console.log(JSON.stringify(params));
		
		this.ibeAdminMarketService.sendEmail(campaignId, emailTo, params).subscribe(
			result => {
				if (result.errors.length === 0) {
					console.log('success');
				} else {
					console.log(result.errors[0]);
				}
			},
			error => {
				console.log(JSON.stringify(error));
			}
		);
	}
	
	
	public async send_ConfirmationEmail_commercial(emailTo = '') {
		let campaignId = 'TAP-EML-EXT-IBE-E001';
		this.sendEmail(campaignId, emailTo, this.CONFIRMATION_COMMERCIAL_JSON);
	}

	public async send_ConfirmationEmail_award(emailTo = '') {
		let campaignId = 'TAP-EML-EXT-IBE-E002';
		this.sendEmail(campaignId, emailTo, this.CONFIRMATION_AWARD_JSON);
	}
	public async send_ConfirmationEmail_TTT(emailTo = '') {
		let campaignId = 'TAP-EML-EXT-IBE-E004';
		this.sendEmail(campaignId, emailTo, this.CONFIRMATION_TTT_JSON);
	}
	
	public async send_TTTexpirationWarningEmail(emailTo = '') {
		let campaignId = 'TAP-EML-EXT-IBE-E005';
		this.sendEmail(campaignId, emailTo, this.TTT_WARNING_JSON);
	}
	
	public async send_TTTexpiredEmail(emailTo = '') {
		let campaignId = 'TAP-EML-EXT-IBE-E006';
		this.sendEmail(campaignId, emailTo, this.TTT_EXPIRED_JSON);
	}
	
	public async send_ConfirmationEmail_stopover(emailTo = '') {
		let campaignId = 'TAP-EML-EXT-IBE-E003';
		this.sendEmail(campaignId, emailTo, this.CONFIRMATION_STOPOVER_JSON);
	}

	// for testing thymeleaf syntax/codes, use 'taxes-test' in ibeadmin campaign
	public async send_ConfirmationEmail_commercial_test(emailTo = '') {
		let campaignId = 'taxes-test';
		this.sendEmail(campaignId, emailTo, this.CONFIRMATION_COMMERCIAL_JSON);
	}

	public async send_addmore(emailTo = '') {
		let campaignId = 'TAP-EML-EXT-IBE-E007';
		this.sendEmail(campaignId, emailTo, this.ADD_MORE_COMMERCIAL_JSON);
	}
}
